'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ScheduledEventItem from './ScheduledEventItem';
import EventCard from '../EventCard';
import { MagicStar } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setEventId } from '@application/features/eventAnalytics/event-analytics-slice';
import { useResponsive } from '@ui/style/useResponsive';
const ScheduledEventsCard = ({ events, onSort, onFilter, sortActive, filterActive, selectedSortText, sendEventName, sendEventId, onPreviewClick, searchValue, onSearchChange, onSearchClear }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isMobileIpadNavigation } = useResponsive();
    const dispatch = useDispatch();
    // const containerRef = useRef<HTMLDivElement>(null);
    const [selectedId, setSelectedId] = React.useState(events.length > 0 ? events[0].id : null);
    useEffect(() => {
        if (events?.length) {
            const firstId = events[0].id;
            setSelectedId(firstId);
            sendEventName?.(events[0].title);
            sendEventId?.(firstId);
            dispatch(setEventId(firstId));
        }
        else {
            setSelectedId(null);
        }
    }, [events, dispatch]);
    const handleSelect = (id) => {
        setSelectedId(id);
        dispatch(setEventId(id));
        const ev = events.find((e) => e.id === id);
        sendEventId?.(id);
        sendEventName?.(ev?.title ?? '');
        if (onPreviewClick) {
            onPreviewClick();
        }
    };
    return (_jsx(EventCard, { padding: isMobileIpadNavigation ? '0px' : undefined, heading: t('events.scheduledEvents'), infoTooltip: t('tooltips.scheduledEvents'), cardHeaderPadding: '2px 16px 16px 16px;', variant: 'light', disableBackground: true, disableShadow: true, disableBorders: true, slider: true, bgPattern: false, showAction: true, icon: _jsx(MagicStar, { variant: 'Outline', color: theme.palette.text.primary }), onSort: onSort, onFilter: onFilter, sortActive: sortActive, filterActive: filterActive, selectedSortText: selectedSortText, showSearch: true, searchValue: searchValue, onSearchChange: onSearchChange, onSearchClear: onSearchClear, sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
        }, children: _jsx(Box, { sx: {
                maxHeight: 'calc(100dvh - 203px)',
                pb: '10px',
                // height: { lg: 'calc(100% - 80px)', xs: 'calc(100dvh - 220px)' },
                overflowY: 'auto',
                px: 1,
                flex: 1,
                minHeight: 0
            }, children: events.length === 0 ? (_jsx(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    py: 10
                }, children: _jsx("span", { style: { color: theme.palette.text.primary }, children: t('events.noScheduledEvents') }) })) : (_jsx(Grid, { container: true, spacing: 2, gap: 1, children: events.map((event) => (_jsx(Grid, { size: {
                        xs: 12
                    }, children: _jsx(ScheduledEventItem, { event: event, selectedId: selectedId, setSelectedId: handleSelect, setSelectedEventName: sendEventName }) }, event.id))) })) }) }));
};
export default ScheduledEventsCard;
